import { Window } from '../utils'

function sendEvent(payload = {}) {
  Window && window.dataLayer.push(payload)
}

export { sendEvent }
